import React from 'react';
import './Footer.scss';

const SectionFooter = ({ title, text, action, theme }) => {
  return (
    <div className={`container-fluid hbi-section-footer ${theme}`}>
      <div className="hbi-title">{title}</div>
      <div className="hbi-text" dangerouslySetInnerHTML={{ __html: text }} />
      <div className="hbi-action">{action}</div>
    </div>
  );
};

export default SectionFooter;